import React from 'react';
import ReactDOM from 'react-dom';
import { v4 as uuidv4 } from 'uuid';
import { ThemeProvider, createGlobalStyle } from 'styled-components';
import { composeWithDevTools } from 'redux-devtools-extension';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';

import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import ReactGA from 'react-ga';

import './index.css';
import App from './components/app';
import * as serviceWorker from './serviceWorker';
import rootReducer, { rootSaga } from './modules';
import 'bootstrap/dist/css/bootstrap.min.css';

const env = process.env.NODE_ENV;
if (env === 'development') {
  localStorage.setItem('aivory_search_keyword', '');
  localStorage.setItem('aivory_session_id', 'test_session');
} else if (!localStorage.getItem('aivory_session_id')) {
  localStorage.setItem('aivory_search_keyword', '');
  localStorage.setItem('aivory_session_id', uuidv4());
  ReactGA.initialize('UA-131502516-18');
} else {
  localStorage.setItem('aivory_search_keyword', '');
  ReactGA.initialize('UA-131502516-18');
}

const customHistory = createBrowserHistory();

customHistory.listen((listener) => {
  ReactGA.set({ page: listener.location.pathname });
  ReactGA.pageview(listener.location.pathname);
});

const sagaMiddleware = createSagaMiddleware({
  context: {
    history: customHistory,
  },
});

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(sagaMiddleware))
);

sagaMiddleware.run(rootSaga);

const GlobalStyle = createGlobalStyle`

body {
  font-family: 'NotoKrR',-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
}

`;

const theme = {
  colors: {
    primary: '#f1c40f',
    soft_pink: '#ffa1a3',
    Secondary01: '#323b45',
    Secondary02: '#6d747b',
    inactive_button: '#f5f5f5',
    placeholder_text: '#b6b9bd',
    cancle_text: '#8a8c8f',
    status_critical: '#ff3b30',
    white: '#ffffff',
    black: '#000000',
    barney_purple: '#8800aa',
    red: '#ff0000',
    nerd_gray_900: '#212121',
    nerd_gray_400: '#bdbdbd',
    nerd_gray_500: '#9e9e9e',
    nerd_gray_300: '#d3d3d3',
    nerd_gray_800: '#323232',
    nerd_gray_50: '#fafafa',
    nerd_gray_600: '#757575',
    nerd_gray_200: '#eeeeee',
    nerd_gray_700: '#424242',
    nerd_blue_gray: '#cfd8d8',
    nerd_green_gray: '#263232',
    nerd_blue_800: '#0355aa',
    nerd_blue_300: '#abcdef',
    nerd_blue_600: '#00aadd',
    nerd_pink: '#ffa1a1',
    nerd_blue_100: '#d8e8f8',
    nerd_blue_50: '#ddeeff',
    nerdblue700: '#0063f7',
  },
};

ReactDOM.render(
  <Router history={customHistory}>
    <Provider store={store}>
      {/* <React.StrictMode> */}
      <ThemeProvider theme={theme}>
        <GlobalStyle />

        <App />
      </ThemeProvider>
      {/* </React.StrictMode> */}
    </Provider>
  </Router>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
